import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { BsPlus, BsDash } from "react-icons/bs";
import { createLoanTypeURL } from "../../../../Library/URLs";
// import { CircularProgress } from "@mui/material";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    width: "552px",
    fontFamily: "Quicksand",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
    fontFamily: "Quicksand",
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2,fontFamily:'Quicksand, sans-serif' }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const CreateLoanType = ({ open, handleClose, updateLoanTypes }) => {
  const unique_id = uuid();
  const { companyid } = useParams();
  const { User } = useSelector((state) => state.payroll);
  const proxyEmployee = useSelector((state) => state.payroll.Proxy);
  const initState = {
    type: "",
    interest_rate_type: "",
    interest_rate: "",
    interest_rate_period: "",
    repayment_type: "",
  };
  const [formData, setFormData] = useState(initState);
  const [interestPeriod, setInterestPeriod] = useState([
    {
      name: "",
      duration: "",
      interest: "",
      min_value: "",
      max_value: "",
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);

  const handlePeriod = (e, id) => {
    const updatedItems = [
      ...interestPeriod.slice(0, id),
      { ...interestPeriod[id], [e.target.name]: e.target.value },
      ...interestPeriod.slice(id + 1),
    ];

    // Update the items state with the updated array
    setInterestPeriod(updatedItems);
  };

  const addRate = () => {
    setInterestPeriod(
      interestPeriod.concat({
        name: "",
        duration: "",
        interest: "",
        min_value: "",
        max_value: "",
      })
    );
  };

  const removeRate = () => {
    const rateLen = interestPeriod.length;
    setInterestPeriod(interestPeriod.slice(0, rateLen - 1));
  };

  const createLoanType = async () => {
    // console.log('all employee API is call')
    setIsLoading(true);
    const raw = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      proxy_id: proxyEmployee?.success?proxyEmployee?.id:null,
      ...formData,
      interest_rate:
        formData?.interest_rate_type === "Fixed" ? formData.interest_rate : "",
      interest_rate_period:
        formData?.interest_rate_type === "Range" ? interestPeriod : "",
    };
    await axios
      .post(createLoanTypeURL, raw)
      .then((res) => {
        setIsLoading(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
          setFormData(initState);
          setInterestPeriod([]);
          handleClose();
          updateLoanTypes();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log("error" + err.message);
        toast.error("Request Failed");
        setIsLoading(false);
      });
  };

  const closeDialog = () => {
    handleClose();
    setFormData(initState);
    setInterestPeriod([
      {
        name: "",
        duration: "",
        interest: "",
        min_value: "",
        max_value: "",
      },
    ]);
  };

  const dashboardTheme = window.localStorage.getItem("theme");

  return (
    <BootstrapDialog
      onClose={closeDialog}
      aria-labelledby="customized-dialog-title"
      open={open}
      // maxWidth={'sm'}
      // fullWidth={true}
      className="Dialog_Wrap"
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={closeDialog}>
        <div className="Name">Create Loan Type</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="">
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Name</label>
              <input
                name="type"
                value={formData.type}
                onChange={(e) =>
                  setFormData({ ...formData, type: e.target.value })
                }
                type="text"
              />
            </div>
          </div>
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Repayment Type</label>
              <select
                name="interest_type"
                value={formData.repayment_type}
                onChange={(e) =>
                  setFormData({ ...formData, repayment_type: e.target.value })
                }
              >
                <option value="" hidden>
                  Choose Repayment Type
                </option>
                <option value="Straight Line">Straight Line</option>
                <option value="Reducing Balance">Reducing Balance</option>
              </select>
            </div>
          </div>
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Interest Rate Type</label>
              <select
                name="interest_type"
                value={formData.interest_rate_type}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    interest_rate_type: e.target.value,
                  })
                }
              >
                <option value="" hidden>
                  Choose Interest Rate Type
                </option>
                <option value="Fixed">Fixed</option>
                <option value="Range">Range</option>
              </select>
            </div>
          </div>
          {formData.interest_rate_type === "Fixed" && (
            <div className="Content_Wrap">
              <div className="Box">
                <label htmlFor="">Interest Rate</label>
                <input
                  name="interest_rate"
                  value={formData.interest_rate}
                  onChange={(e) =>
                    setFormData({ ...formData, interest_rate: e.target.value })
                  }
                  type="text"
                />
              </div>
            </div>
          )}
          {formData?.interest_rate_type === "Range"
            ? interestPeriod.map((item, id) => (
                <div className="Range_Wrap" key={id}>
                  <h6>{id + 1}.</h6>
                  <div className="Content_Wrap">
                    <div className="Box">
                      <label htmlFor="">Name</label>
                      <input
                        name="name"
                        value={interestPeriod[id]?.name}
                        onChange={(e) => handlePeriod(e, id)}
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="Content_Wrap">
                    <div className="Box">
                      <label htmlFor="">Duration</label>
                      <input
                        name="duration"
                        value={interestPeriod[id]?.duration}
                        onChange={(e) => handlePeriod(e, id)}
                        type="text"
                      />
                    </div>
                    <div className="Box">
                      <label htmlFor="">Interest</label>
                      <input
                        name="interest"
                        value={interestPeriod[id]?.interest}
                        onChange={(e) => handlePeriod(e, id)}
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="Content_Wrap">
                    <div className="Box">
                      <label htmlFor="">Minimum Amount</label>
                      <input
                        name="min_amount"
                        value={interestPeriod[id]?.min_amount}
                        onChange={(e) => handlePeriod(e, id)}
                        type="text"
                      />
                    </div>
                    <div className="Box">
                      <label htmlFor="">Maximum Amount</label>
                      <input
                        name="max_amount"
                        value={interestPeriod[id]?.max_amount}
                        onChange={(e) => handlePeriod(e, id)}
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              ))
            : null}
          {formData.interest_rate_type === "Range" && (
            <div className="Dynamic_Btn_Wrapper">
              {interestPeriod.length > 1 && (
                <button className="RateBtn" type="button" onClick={removeRate}>
                  <BsDash />
                </button>
              )}
              <button
                className="RateBtn add_rate"
                type="button"
                onClick={addRate}
              >
                <BsPlus />
              </button>
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Pay_Item_Btn_Action_Wrapper">
          <div className="Btn" onClick={handleClose}>
            Cancel
          </div>

          <div
            className="Btn"
            onClick={createLoanType}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <span className="spinner-border spinner-grow-sm" />
            ) : (
              "Create"
            )}
          </div>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default CreateLoanType;
